import styled from 'styled-components';

export const HeaderElectronicBillWrapper = styled.div`
  width: 100%;
  padding: ${p => p.theme.app.padding.horizontal};
  background: #f8f8f8;
  border-radius: 12px;

  display: flex;
  align-items: center;
  gap: 12px;
`;
